export * from './ArrowDUturnRightUpIcon';
export * from './ArrowDUturnRightUpIcon16Light';
export * from './ArrowDUturnRightUpIcon16Regular';
export * from './ArrowDUturnRightUpIcon16Solid';
export * from './ArrowDUturnRightUpIcon20Light';
export * from './ArrowDUturnRightUpIcon20Regular';
export * from './ArrowDUturnRightUpIcon20Solid';
export * from './ArrowDUturnRightUpIcon24Regular';
export * from './ArrowDUturnRightUpIcon24Solid';
export * from './ArrowDUturnRightUpIcon32Regular';
export * from './ArrowDUturnRightUpIcon64Regular';
